define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Action",
	"csi/def/Field",
	"csi/def/ViewRef",
	"csi/form/Widget",
	"csi/reflection",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query",
	"./ThemeColorwayToColorwayMappingMixin"
], function(declare, lang, def, Action, Field, ViewRef, Widget, reflection, csiStore, Names, xml, Query, ThemeColorwayToColorwayMappingMixin) {

	return declare([Widget, ThemeColorwayToColorwayMappingMixin], {

		FIELD_ADD_TO_BOMS: "AddToBOMs",
		FIELD_COLOR_COLORWAYS: "ColorColorways",
		FIELD_CREATE_COLORWAY: "CreateColorway",
		FIELD_STYLES: "Styles",
		FIELD_UPDATE_ATTRIBUTES: "UpdateAttributes",
		FIELD_UPDATE_COLORWAY_NAME: "UpdateColorwayName",

		_resolveView: function() {
			// TA30495: If mapped attributes have been defined then add a prompt below the node name prompt “Update mapped attributes?"
			if (this._isColorwayAttributeMappingExists(this.getFormSourceNode())) {
				this.defView.addFieldAfter(lang.mixin(new Field(), {
					m_label: this.FIELD_UPDATE_ATTRIBUTES,
					m_typeControl: def.FIELD_CHECKBOX,
					idParameter: this.FIELD_UPDATE_ATTRIBUTES,
					bPersist: true
				}), "UpdateColorwayName");
			}
			this.inherited(arguments);
		},

		_buildView: function() {
			var rc = reflection.getClass("Colorway");
			var rca = rc.getAttribute(xml.ATTR_NAME);
			if (rca.hasActiveExpression) {
				this.defView.removeField(this.FIELD_UPDATE_COLORWAY_NAME);
			}

			this.addDefaultValue(this.FIELD_CREATE_COLORWAY, true);
			this.addDefaultValue(this.FIELD_ADD_TO_BOMS, true);


			this.inherited(arguments);
		},

		_getStoreOptions: function(/*Field*/ field) {
			return csiStore.namesOptionsByRelationship(this.getContext(), field.m_relationship);
		},

		getFieldStore: function(/*Field*/field, /*String*/value) {
			switch (field.getControlName()) {
				case this.FIELD_COLOR_COLORWAYS:
					var storeOptions = this._getStoreOptions(field);
					storeOptions.action = lang.mixin(new Action(), {
						m_viewRef: lang.mixin(new ViewRef(), {
							m_id: "ColorColorwaysTable",
							m_url: this.getViewNode()
						})
					});
					return new Names(storeOptions);
				case this.FIELD_STYLES:
					var storeOptions = this._getStoreOptions(field);
					storeOptions.action = lang.mixin(new Action(), {
						m_viewRef: lang.mixin(new ViewRef(), {
							m_id: "PropagateThemeColorwaysStyles",
							m_url: this.getViewNode()
						})
					});
					return new Names(storeOptions);
				default:
					return this.inherited(arguments);
			}
		}

	});
});